export const getBrandingColor = (color?: string) => color || '#000';
